module.exports = __webpack_public_path__ + "img/one-line-light.8eab54ae.png";